import { api } from '@/shared/lib/axios.ts';
import type { MaintenanceRow, MaintenanceListResponse, MaintenanceListParams } from '@/shared/types/maintenance.ts';

export interface CreateMaintenanceDTO {
  titulo: string;
  descricao?: string;
  tipo: 'AGENDADA' | 'RETROATIVA';
  iniciadoEm: string;
  encerradoEm: string;
  tenantIds?: string[];
  selectAll?: true;
}

export interface UpdateMaintenanceDTO {
  titulo?: string;
  descricao?: string;
  iniciadoEm?: string;
  encerradoEm?: string;
}

export async function listMaintenances(params: MaintenanceListParams): Promise<MaintenanceListResponse> {
  const { data } = await api.get<MaintenanceListResponse>('/admin/maintenances', { params });
  return data;
}

export async function getMaintenance(id: string): Promise<MaintenanceRow> {
  const { data } = await api.get<MaintenanceRow>(`/admin/maintenances/${id}`);
  return data;
}

export async function createMaintenance(input: CreateMaintenanceDTO): Promise<MaintenanceRow> {
  const { data } = await api.post<MaintenanceRow>('/admin/maintenances', input);
  return data;
}

export async function updateMaintenance(id: string, input: UpdateMaintenanceDTO): Promise<MaintenanceRow> {
  const { data } = await api.put<MaintenanceRow>(`/admin/maintenances/${id}`, input);
  return data;
}

export async function deleteMaintenance(id: string): Promise<MaintenanceRow> {
  const { data } = await api.delete<MaintenanceRow>(`/admin/maintenances/${id}`);
  return data;
}
